<template>
	<aside
		class="sanity-rich-text-component block--inline-cta-panel article-cta cta-type--inline-link pl-100 pt-100 pr-100 pb-100 mt-150 mb-150"
	>
		<div class="position-relative">
			<p v-if="props.value.panelHeading" class="heading-6 font-weight-lighter">{{ props.value.panelHeading }}</p>
			<BaseCtaLink
				v-if="link"
				data-test="inline-cta-panel-link"
				:link="link"
				icon="arrow-bold"
				classes="body-lg"
			/>
		</div>
	</aside>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Link } from 'types/layout';
import { PortableTextComponentProps } from '@portabletext/vue';
import { SanityRichTextInlineCtaPanel } from 'types/sanity';

type Props = PortableTextComponentProps<SanityRichTextInlineCtaPanel>;
const props = defineProps<Props>();

const link = computed((): Link | null => {
	const cta = props.value.panelCta;
	if (!cta || !cta.url) {
		return null;
	}
	const text = cta.linkText || cta.url;
	return {
		text,
		href: cta.url,
		target: cta.openInNewTab ? '_blank' : ''
	};
});
</script>
